class HelpCenter extends HTMLElement {
  constructor() {
      super();

      this.details = [...this.querySelectorAll('details')].filter(x => x.dataset.target && x.dataset.target.length);

      this.bindClicks();
  }

  bindClicks() {
      if (this.details.length) {
          for (const detail of this.details) {
              detail.addEventListener('click', this.clickHandler.bind(this));
          }
      }
  }

  clickHandler(e) {
      let details = e.target.closest('details');

      window.location = details.dataset.target;
  }
}

customElements.define('help-center', HelpCenter);

class FeaturedFaqs extends HTMLElement {
  constructor() {
    super();

    this.getFeaturedFaqs('/?sections=featured-faqs').then(response => {
      let data = JSON.parse(response);

      if (data) {
        this.innerHTML = data['featured-faqs'];
      }
    });
  }

  async getFeaturedFaqs(url) {
    const response = await fetch(url);
    const text = await response.text();

    return text;
  }
}

customElements.define('featured-faqs', FeaturedFaqs);